import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "contestdream.graphic.icon",
  "use": "contestdream.graphic.icon-usage",
  "viewBox": "0 0 162.7 212.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 162.7 212.1\" id=\"contestdream.graphic.icon\"><style>#contestdream.graphic.icon .st0{fill:#46ccd5}</style><path id=\"contestdream.graphic.icon_Subtraction_91\" class=\"st0\" d=\"M162.7,212.1H0V0h162.7V212.1z M7.7,6.8v198.5h147.4V6.8H7.7z\" /><path class=\"st0\" d=\"M85.1,31.4c-0.8-1.3-2.3-2-3.8-2c-1.5,0-2.9,0.7-3.8,2l-32,50.3v96.7c0,2.4,1.9,4.3,4.3,4.3 c2.4,0,4.3-1.9,4.3-4.3V84.2L71,57.9c4,2.2,12.5,5.4,20.9,0.3l16.6,26.1v94.2c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.9,4.3-4.3V81.7 L85.1,31.4z\" /><path class=\"st0\" d=\"M81.4,86.9c-2.4,0-4.3,1.9-4.3,4.3v87.2c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.9,4.3-4.3V91.2 C85.7,88.8,83.8,86.9,81.4,86.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/contestdream.graphic.icon.svg
// module id = 3UWC
// module chunks = 13